import React from 'react';
import PropTypes from 'prop-types';
import { ShippingThreshold } from './ShippingThreshold';
import {
  formatDate,
  formatWeek
} from '../../../helper/utils';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { FULFILLMENT_METHODS } from '../../../constants';

export const ApplianceShipping = ({
  deliveryStartDate,
  hasFreeShipping
}) => {
  const startDate = formatDate(deliveryStartDate);
  const formattedEarliestDelivery = formatWeek(deliveryStartDate, true, startDate);
  return (
    <div className="fulfillment-tile">
      <TileHead
        title="Delivery"
      />
      <div className="fulfillment__sub-title">
        {deliveryStartDate && (
          <>
            <div className="delivery-timeline">Earliest delivery date</div>
            <div className="u__bold fulfillment-qty-row">
              {formattedEarliestDelivery}
            </div>
          </>
        )}
      </div>
      <TileFooter>
        <ShippingThreshold
          type={FULFILLMENT_METHODS.APPLIANCE}
          hasFreeShipping={hasFreeShipping}
        />
      </TileFooter>
    </div>
  );
};

ApplianceShipping.propTypes = {
  deliveryStartDate: PropTypes.string,
  hasFreeShipping: PropTypes.bool
};

ApplianceShipping.defaultProps = {
  deliveryStartDate: null,
  hasFreeShipping: false
};
